import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setPlay } from "actions/gamePlay";
import { setClassicDicePayout, setClassicDiceChance, setClassicDiceType } from "actions/gameDice";
import $ from "jquery";
import ionRangeSlider from "ion-rangeslider";
import { isValidNumber, wait, isMobile, playAudio } from 'utils/Helper';
import storage from "utils/Storage";

class Game extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            margin: 'mt-2',
            marginBottom: 'mb-1',
            under_over: (50).toFixed(2),
            win_chance: (50).toFixed(2),
            payout: (1.98).toFixed(4),
            px: null,
            type: "Under",
            currentRange: 50,
            over_value: 50,
            under_value: 50,
            style: ''
        };
        this.handleResize = this.handleResize.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        //Prevent For Error, IMPORTANT
        this.props.setPlay(false);

        // Redux set Play
        if (nextProps.classic_dice_result) {
            this.playDice(nextProps.classic_dice_result);
        }
    }

    handleResize() {
        if (isMobile()) {
            this.setState({ margin: "mt-2", marginBottom: 'mb-0', px: 'px-1', style: '#fd6638' });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.setClassicDiceChance(50);
        this.props.setClassicDicePayout(1.9800);
        this.props.setClassicDiceType("Under");

        wait(300).then(() => {
            this.handleResize();
        });

        let self = this;

        $("#range").ionRangeSlider({
            type: "single",
            skin: "big",
            min: 0,
            max: 100,
            from: 50,
            grid: true,
            from_min: 2,
            from_max: 98,
            onChange: function (data) {
                playAudio('dice.mp3')
                let value = parseFloat(data.from);
                self.props.setClassicDiceChance(value);
                self.setState({ currentRange: value })
                wait(50).then(() => {
                    self.calculateFields(value);
                })
            }
        });

        let dice = document.querySelector('.dice-result .roll');
        dice.style.transform = `translateX(${50}%)`;
    }

    handleInputChange = (e) => {
        let target = e.target;
        let value = target.value;
        let name = target.name;
        if (!isValidNumber(value)) return;

        if (name === 'win_chance' || name === 'under_over') {
            if (parseFloat(value) > 98) return;
            if (parseFloat(value) < 2) return;

            value = parseFloat(value)

            this.setState({ 'win_chance': value.toFixed(2) });
            this.setState({ 'under_over': value.toFixed(2) });

            if (this.state.type === "Over")
                this.setState({ over_value: value.toFixed(2) });
            else
                this.setState({ under_value: value.toFixed(2) });
        }
    };

    playDice = (val) => {
        $('.irs-to').html(val);
        let dice = document.querySelector('.dice-result .roll');
        let instanceText = document.querySelector('.dice-result span');
        instanceText.style.display = 'block';
        instanceText.innerText = val.toFixed(2) + 'x';
        let fix = 7;
        val = parseFloat(val);

        if (isMobile()) {
            if (val < 10) {
                val = 11;
            }
            else if (val > 90) {
                fix = 0;
                val = 90;
            }
        }
        else {
            if (val > 90) {
                fix = 2;
                val = 90;
            }
        }

        dice.style.transform = `translateX(${val + fix}%)`;
    };

    rollChange = () => {
        let { type, currentRange } = this.state;
        var val = currentRange;

        if (type === "Under") {
            this.props.setClassicDiceType("Over");
            this.setState({ type: "Over" });
            val = 100 - currentRange;
        }
        else {
            this.props.setClassicDiceType("Under");
            this.setState({ type: "Under" });
            val = currentRange;
        }

        wait(1).then(() => {
            this.setSlide(val);
            this.calculateFields(val);
        })
    };

    setSlide = (val) => {
        let instance = $("#range").data("ionRangeSlider");
        instance.update({ from: val });
    };

    calculateFields = (value) => {
        let { type, over_value, currentRange } = this.state;
        this.setState({ under_over: value.toFixed(2) });
        let chance = this.state.type === "Over" ? 100 - value : value;
        this.setState({ win_chance: chance.toFixed(2) });

        this.setState({ over_value: value.toFixed(2), under_value: value.toFixed(2) });

        var max = type === "Under" ? 100 : 150;
        var min = 0;

        if (value < 48) {
            min = .020;
        }
        else min = .020;

        var payout = max / value - min;

        if (type === "Over") {
            payout = value / 2 + min;
        }

        this.setState({ payout: payout.toFixed(4) })
        this.props.setClassicDicePayout(parseFloat(payout.toFixed(4)));
        this.props.setClassicDiceChance(value);
    }

    render() {
        let { margin, marginBottom, px, type } = this.state;

        return (
            <>
                <Row className="mt-4">
                    <Col sm={12} md={12} className={'m-auto'}>
                        <Card className={'my-2 ras py-0 bg-dice-options'}>
                            <Card.Body className={px + ' ' + type}>
                                <div className="dice-result" >
                                    <div className="roll" >
                                        <img id="cDice" className="img-fluid" src="/assets/images/dice.png" style={{width:"70px",marginLeft:"13px"}} />
                                        <span style={{width:"100px",border:"5px solid #31343c",padding:"2px",backgroundColor:"#23262b",color:"white"}}>50.00x</span>
                                    </div>
                                </div>
                                <input type="text" id="range" />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row style={{height:"76vh"}} >
                    <Col sm={12} md={12} className={'m-auto'} >
                        <Card className={marginBottom + ' bg-dice-options'} >
                            <Card.Body className={px + ' g-dice py-0'}>
                                <Row>
                                    <Col sm={12} md={10} className={margin + ' mx-auto'}  style={{backgroundColor:"#222328",borderRadius:"2rem",padding:"10px"}}>
                                        <Row>
                                            <Col md={5} className={'col-5 mt-1'}>
                                                <div className={"form-group cashout"}>
                                                    <div className="form-group text-left">
                                                        <label htmlFor={'payout'} style={{marginLeft:"20px"}}  className="game-fonts">
                                                            Payout
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                type="text"
                                                                readOnly={true}
                                                                className="form-control text-left"
                                                                id="payout"
                                                                name="payout"
                                                                value={this.state.payout}
                                                                autoComplete={"off"} 
                                                                style={{
                                                                    // borderTopLeftRadius:"2rem",
                                                                    // borderBottomLeftRadius:"2rem",
                                                                    backgroundColor:"#2a2b32",
                                                                    paddingLeft:"15px"
                                                                
                                                                }}
                                                               
                                                               />
                                                            <div className="input-group-append hidden-sm"
                                                           
                                                            >
                                                                <span className="input-group-text  font-19"
                                                                 style={{
                                                                    // borderTopRightRadius:"2rem",
                                                                    // borderBottomRightRadius:"2rem",
                                                                    backgroundColor:"#2a2b32",
                                                                    color:"#43b309"

                                                                }}
                                                                >
                                                                    <i className="mdi mdi-close" />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={5} className={'col-5 mt-1'}>
                                                <div className={"form-group text-left"}>
                                                    <label onClick={this.rollChange} htmlFor={'win_chance'} style={{marginLeft:"20px"}}  className="game-fonts" >
                                                        Roll {type}
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            readOnly={true}
                                                            style={{ background: this.state.style ,
                                                                //  borderTopLeftRadius:"2rem",
                                                                // borderBottomLeftRadius:"2rem",
                                                                backgroundColor:"#2a2b32",
                                                                paddingLeft:"15px"}}
                                                            className="form-control cpt text-left"
                                                            id="under_over"
                                                            name="under_over"
                                                            value={this.state.under_over}
                                                            // onClick={this.rollChange}
                                                            
                                                        />
                                                        <div className="input-group-append cpt hidden-sm" onClick={this.rollChange}>
                                                            <span className="input-group-text " 
                                                             style={{
                                                                // borderTopRightRadius:"2rem",
                                                                // borderBottomRightRadius:"2rem",
                                                                backgroundColor:"#2a2b32",
                                                                color:"#43b309"

                                                            }}
      
                                                            >
                                                                <i className={"mdi mdi-rotate-3d font-15 Over-" + type} />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col md={10} className={'col-10'}>
                                                <div className={"form-group text-left"}>
                                                    <label htmlFor={'win_chance'}>
                                                        <span className={'hidden-sm game-fonts'} 
                                                        style={{marginLeft:"20px"}} 
                                                        >Win</span> Chance
                                                    </label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            readOnly={true}
                                                            className="form-control text-left"
                                                            id="win_chance"
                                                            name="win_chance"
                                                            value={this.state.win_chance}
                                                            autoComplete={"off"} 
                                                            style={{
                                                                // borderTopLeftRadius:"2rem",
                                                                // borderBottomLeftRadius:"2rem",
                                                                backgroundColor:"#2a2b32",
                                                                paddingLeft:"15px",
                                                                
                                                            
                                                            }}
                                                            />
                                                        <div className="input-group-append hidden-sm">
                                                            <span className="input-group-text font-19" 
                                                             style={{
                                                                // borderTopRightRadius:"2rem",
                                                                // borderBottomRightRadius:"2rem",
                                                                backgroundColor:"#2a2b32",
                                                                color:"#43b309",
                                                                padding:"0px 4px",
                                                                gap:"5px"
                                                                

                                                            }}

                                                            >
                                                                %
                                                                <div style={{display:"flex",width:"160px",gap:"2px", height:"35px",color:"white"}} className="game-fonts font-14">
                                                                    <div 
                                                                    style={{
                                                                        width:"100%",
                                                                        backgroundColor:"#31343c",
                                                                        // borderTopLeftRadius:"2rem",
                                                                        // borderBottomLeftRadius:"2rem"
                                                                        alignItems:"center",
                                                                        textAlign:"center",
                                                                        justifyContent:"center",
                                                                        display:"flex",
                                                                        cursor:"pointer"

                                                                        }}>
                                                                        Min
                                                                    </div>
                                                                    <div style={{
                                                                        width:"100%",
                                                                        backgroundColor:"#31343c",
                                                                        alignItems:"center",
                                                                        textAlign:"center",
                                                                        justifyContent:"center",
                                                                        display:"flex",
                                                                        cursor:"pointer"
                                                                        
                                                                        }}>
                                                                        -5
                                                                    </div>
                                                                    <div style={{
                                                                        width:"100%",
                                                                        backgroundColor:"#31343c",
                                                                        alignItems:"center",
                                                                        textAlign:"center",
                                                                        justifyContent:"center",
                                                                        display:"flex",
                                                                        cursor:"pointer"
                                                                        
                                                                        }}>
                                                                        +5
                                                                    </div>
                                                                    <div style={{
                                                                        width:"100%",
                                                                        backgroundColor:"#31343c",
                                                                        // borderBottomRightRadius:"2rem",
                                                                        // borderTopRightRadius:"2rem"
                                                                        alignItems:"center",
                                                                        textAlign:"center",
                                                                        justifyContent:"center",
                                                                        display:"flex",
                                                                        cursor:"pointer"
                                                                        }}>
                                                                        Max
                                                                    </div>

                                                                </div>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </>
        );
    }
}

Game.propTypes = {
    setPlay: PropTypes.func,
    play: PropTypes.bool,
    classic_dice_result: PropTypes.number,
    classic_dice_chance: PropTypes.number
};

const mapStateToProps = state => ({
    play: state.items.play,
    classic_dice_result: state.items.classic_dice_result,
    classic_dice_chance: state.items.classic_dice_chance,
});

export default connect(mapStateToProps, { setPlay, setClassicDicePayout, setClassicDiceChance, setClassicDiceType })(Game);